import {useEffect, useMemo, useState} from "react";
import {useProfile} from "@brg/auth";
import { API, Endpoints } from "@brg/api";

export const useGetIsPendingProject =
    (teamTitle: string, projectId: string, lang = 'en', disabled?: boolean) => {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const profile = useProfile();

        useEffect(() => {
            if (disabled || !profile?.accountId || !projectId || !teamTitle) {
                setIsLoading(false);
            }
        }, [disabled, profile?.accountId])

        useEffect(() => {
            if (!disabled && profile?.accountId && projectId && teamTitle) {
                setIsLoading(true);
                API.fetch((`${Endpoints.geograffee}/api/Team/GetList?isContextIgnored=true&isLite=true&pendingProjectIds=${projectId}`), {})
                    .then((res) => {
                        return res.json()
                    })
                    .then((r) => {
                        setIsLoading(false);
                        if (r?.data) {
                            setResp(API.toLang(r?.data, lang))
                        }
                    }).catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
            }
        }, [disabled, lang, profile?.accountId, projectId, teamTitle])

        const isPending = useMemo(() =>{
            return resp ? resp?.findIndex((res: any) => res?.contextName === teamTitle) !== -1 : false;
        },
            [resp, teamTitle])

        return [isPending, isLoading, error];
}import {useEffect, useMemo, useState} from "react";
import {useProfile} from "@brg/auth";
import { API, Endpoints } from "@brg/api";

export const useGetIsPendingProject =
    (teamTitle: string, projectId: string, lang = 'en', disabled?: boolean) => {
        const [resp, setResp] = useState<any>([]);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const profile = useProfile();

        useEffect(() => {
            if (disabled || !profile?.accountId || !projectId || !teamTitle) {
                setIsLoading(false);
            }
        }, [disabled, profile?.accountId])

        useEffect(() => {
            if (!disabled && profile?.accountId && projectId && teamTitle) {
                setIsLoading(true);
                API.fetch((`${Endpoints.geograffee}/api/Team/GetList?isContextIgnored=true&isLite=true&pendingProjectIds=${projectId}`), {})
                    .then((res) => {
                        return res.json()
                    })
                    .then((r) => {
                        setIsLoading(false);
                        if (r?.data) {
                            setResp(API.toLang(r?.data, lang))
                        }
                    }).catch((e) => {
                    setIsLoading(false);
                    setError(true);
                })
            }
        }, [disabled, lang, profile?.accountId, projectId, teamTitle])

        const isPending = useMemo(() =>{
            return resp ? resp?.findIndex((res: any) => res?.contextName === teamTitle) !== -1 : false;
        },
            [resp, teamTitle])

        return [isPending, isLoading, error];
}